
// Initialize API client
const apiClient = new APIClient({
    baseUrl: 'https://trading-app-fbe55f957348.herokuapp.com',
    timeout: 15000
});

let isGenerating = false;
let generatedCardData = null;

let previewReqAbort = null;
let previewDebounce;
let selectedTheme = 'light'; // Default theme

const PREVIEW_DEBOUNCE_MS = 200;

document.addEventListener('DOMContentLoaded', function () {

    document.getElementById('babyName').addEventListener('input', function(e) {
        document.getElementById('babyNameCount').textContent = e.target.value.length;
    });

    document.getElementById('latestMilestone').addEventListener('input', function(e) {
        document.getElementById('milestoneCount').textContent = e.target.value.length;
    });

    document.getElementById('email').addEventListener('input', function(e) {
        document.getElementById('emailCount').textContent = e.target.value.length;
    });

});
// 3D Card hover effect
function handleCardHover(event) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const card = event.currentTarget;
    const rect = card.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    const centerX = rect.width / 2;
    const centerY = rect.height / 2;
    const rotateX = (y - centerY) / 25;
    const rotateY = (centerX - x) / 25;

    const cardElement = card.querySelector('.card-inner');
    if (cardElement) {
        cardElement.style.transform = `rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(1.03)`;
    }

    const glimmer = card.querySelector('.glimmer-overlay');
    if (glimmer) {
        const linePosition = 50 + (rotateY * 4) + (rotateX * 2);
        const angle = 45 + (rotateX * 2);

        glimmer.style.background = `
            linear-gradient(${angle}deg,
                transparent 0%,
                transparent ${Math.max(0, linePosition - 15)}%,
                rgba(255,255,255,0.1) ${Math.max(0, linePosition - 10)}%,
                rgba(255,255,255,0.3) ${Math.max(0, linePosition - 5)}%,
                rgba(255,255,255,0.6) ${linePosition}%,
                rgba(255,255,255,0.3) ${Math.min(100, linePosition + 5)}%,
                rgba(255,255,255,0.1) ${Math.min(100, linePosition + 10)}%,
                transparent ${Math.min(100, linePosition + 15)}%,
                transparent 100%)
        `;
        glimmer.style.opacity = '0.8';
    }
}

function toAbsolute(url) {
    if (!url) return '';
    // If already absolute, leave it alone
    if (/^https?:\/\//i.test(url)) return url;

    // Always prepend your Azure app URL to relative paths
    const base = 'https://customer-app-trading-card-hpdsf4d7d2f8cwav.eastus2-01.azurewebsites.net/';
    try {
        return new URL(url, base).href;
    } catch {
        return base.replace(/\/$/, '') + '/' + url.replace(/^\//, '');
    }
}

// Turn API response (either {card:{...}} or just {...}) into our local shape
function normalizeCard(api) {
    const c = api?.card ?? api ?? {};

    // IDs can be `id` (getCard) or `cardId` (generateCard)
    const id = c.id || c.cardId;

    // Image URLs can be `generatedCardUrl` (getCard) or `cardUrl` (generateCard)
    const imageUrlRaw = c.generatedCardUrl || c.cardUrl || c.imageUrl;

    // Original image URL can vary too
    const originalRaw =
        c.originalImageUrl || c.originalUrl || c.originalImage;

    // Optional metadata—present in getCard, not in generateCard
    const teamId = c.teamId || c.favoriteTeam || null;
    const milestone = c.milestone || c.latestMilestone || null;
    const babyName = c.babyName || null;

    const currentParams = new URLSearchParams(window.location.search);
    currentParams.set('cardId', id); // Add or update cardId
    const baseUrl = window.location.origin + window.location.pathname;
    const shareUrl = `${baseUrl}?${currentParams.toString()}`;

    return {
        id,
        babyName,
        milestone,
        teamId,
        createdAt: c.createdAt || new Date().toISOString(),
        imageUrl: toAbsolute(imageUrlRaw),
        originalImageUrl: toAbsolute(originalRaw),
        shareUrl: shareUrl,
    };
}

function handleCardLeave(event) {
    const card = event.currentTarget;
    const cardElement = card.querySelector('.card-inner');
    if (cardElement) {
        cardElement.style.transform = 'rotateX(0deg) rotateY(0deg) scale(1)';
    }
    const glimmer = card.querySelector('.glimmer-overlay');
    if (glimmer) {
        glimmer.style.background = 'transparent';
        glimmer.style.opacity = '0';
    }
}

// Mobile view toggle
function toggleMobileView(view) {
    const formPanel = document.getElementById('formPanel');
    const previewPanel = document.getElementById('previewPanel');
    const mobilePreviewBtn = document.getElementById('mobilePreviewBtn');
    const toggleButtons = document.querySelectorAll('.toggle-button');

    if (view === 'form') {
        formPanel.classList.remove('hidden');
        previewPanel.classList.remove('visible');
        mobilePreviewBtn.classList.remove('hidden');
        toggleButtons[0].classList.add('active');
        toggleButtons[1].classList.remove('active');
    } else {
        formPanel.classList.add('hidden');
        previewPanel.classList.add('visible');
        mobilePreviewBtn.classList.add('hidden');
        toggleButtons[0].classList.remove('active');
        toggleButtons[1].classList.add('active');
    }
}

// File handling
function handleFileSelect(input) {
    const file = input.files[0];
    if (file) {
        const reader = new FileReader();
        reader.onload = function(e) {
            document.getElementById('previewImg').src = e.target.result;
            const imagePreview = document.getElementById('imagePreview');
            imagePreview.style.display = 'flex';
            imagePreview.style.flexDirection = 'column';
            document.querySelector('.file-upload-area').style.display = 'none';
            updatePreview();
        };
        reader.readAsDataURL(file);
    }
}



function removeImage() {
    const fileInput = document.getElementById('file-upload');
    if (fileInput) {
        fileInput.value = '';
    }
    document.getElementById('imagePreview').style.display = 'none';
    document.getElementById('imageEditorContainer').style.display = 'none';
    document.querySelector('.file-upload-area').style.display = 'block';
    window.croppedImageFile = null;
    updatePreview();
}

function selectLogo(theme) {
    selectedTheme = theme;

    // Update button states
    document.querySelectorAll('.logo-selector-btn').forEach(btn => {
        const isActive = btn.getAttribute('data-logo') === theme;
        btn.classList.toggle('active', isActive);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    // Trigger preview update
    updatePreview();
}




// Preview update
let previewTimeout;
function updatePreview() {
    clearTimeout(previewTimeout);
    previewTimeout = setTimeout(() => {
        // call the debounced API request
        requestPreviewDebounced();
    }, PREVIEW_DEBOUNCE_MS); // you can keep 500ms if you prefer
}

// Form validation
function validateForm(event) {
    event.preventDefault();

    let isValid = true;
    const errors = {};

    // Validate baby name
    const babyName = document.getElementById('babyName').value.trim();
    if (!babyName) {
        errors.babyName = 'Baby Name is required';
        isValid = false;
    }

    // Validate team selection
    const favoriteTeam = document.getElementById('favoriteTeam').value;
    if (!favoriteTeam) {
        errors.team = 'Please select a favorite team';
        isValid = false;
    }

    // Validate milestone
    const milestone = document.getElementById('latestMilestone').value.trim();
    if (!milestone) {
        errors.milestone = 'Please share a milestone';
        isValid = false;
    }

    // Validate email
    const email = document.getElementById('email').value.trim();
    if (!email) {
        errors.email = 'Email address is required';
        isValid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        errors.email = 'Please enter a valid email address';
        isValid = false;
    }

    // Validate image
    const fileInput = document.getElementById('file-upload');
    if (!fileInput.files[0]) {
        errors.image = 'Please upload a family photo';
        isValid = false;
    }

    // Validate age
    const age = document.getElementById('age').value;
    if (!age) {
        errors.age = 'Age is required';
        isValid = false;
    }

    // Validate weight
    const weight = document.getElementById('weight').value;
    if (!weight) {
        errors.weight = 'Weight is required';
        isValid = false;
    }

    // Validate height
    const height = document.getElementById('height').value;
    if (!height) {
        errors.height = 'Height is required';
        isValid = false;
    }

    // Show errors
    if (!isValid) {
        // Clear previous errors
        document.querySelectorAll('.error-message').forEach(el => {
            el.style.display = 'none';
            el.textContent = '';
        });

        // Show new errors (clear first for screen reader re-announcement)
        for (const [field, message] of Object.entries(errors)) {
            const errorElement = document.getElementById(field + 'Error');
            if (errorElement) {
                errorElement.textContent = '';
                errorElement.style.display = 'block';
                requestAnimationFrame(() => { errorElement.textContent = message; });
            }
        }

        // Focus on first error field
        const firstErrorField = Object.keys(errors)[0];
        if (firstErrorField === 'image') {
            document.querySelector('.file-upload-area').scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else if (firstErrorField === 'team') {
            document.querySelector('.team-selector-grid').scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
            const field = document.getElementById(firstErrorField.replace('Error', ''));
            if (field) {
                field.scrollIntoView({ behavior: 'smooth', block: 'center' });
                field.focus();
            }
        }

        return false;
    }





    return true;
}

// editor functionality
// Image Editor Implementation
class ImageEditor {
    constructor(containerId) {
        this.container = document.getElementById(containerId);
        this.editorContent = document.getElementById('editorContent');
        this.canvas = null;
        this.ctx = null;
        this.imageElement = null;
        this.imageState = {
            scale: 1,
            x: 0,
            y: 0,
            naturalWidth: 0,
            naturalHeight: 0
        };
        this.isDragging = false;
        this.dragStart = { x: 0, y: 0 };

        // Configuration from app-config.js
        this.configPhotoWidth = 940;  // From cardTemplate.familyPhotoArea.dimensions.width
        this.configPhotoHeight = 1210; // From cardTemplate.familyPhotoArea.dimensions.height
        this.displayScale = 0.413;    // Adjusted UI display scale for better viewing

        // Detect if mobile (screen width <= 768)
        const isMobile = window.innerWidth <= 768;
        const scaleFactor = isMobile ? this.displayScale * 0.7 : this.displayScale;

        this.CANVAS_WIDTH = Math.round(this.configPhotoWidth * scaleFactor);
        this.CANVAS_HEIGHT = Math.round(this.configPhotoHeight * scaleFactor);
    }

    async init(file, onCrop, onCancel) {
        this.file = file;
        this.onCrop = onCrop;
        this.onCancel = onCancel;

        this.container.style.display = 'block';
        this.showLoading();

        try {
            // Convert HEIC if necessary
            let imageFile = file;
            if (file.type === 'image/heic' || file.type === 'image/heif' || file.name.toLowerCase().endsWith('.heic')) {
                imageFile = await this.convertHeicToJpeg(file);
            }

            await this.loadImage(imageFile);
            this.setupCanvas();
            this.drawImage();
        } catch (error) {
            this.showError(error.message);
        }
    }

    async convertHeicToJpeg(heicFile) {
        try {
            const blob = await heic2any({
                blob: heicFile,
                toType: 'image/jpeg',
                quality: 0.9  // Match jpegQuality from config
            });

            return new File([blob], heicFile.name.replace(/\.heic$/i, '.jpg'), {
                type: 'image/jpeg',
                lastModified: Date.now()
            });
        } catch (error) {
            throw new Error('Failed to convert HEIC image. Please try a different image.');
        }
    }

    showLoading() {
        this.editorContent.innerHTML = `
            <div class="editor-loading">
                <div class="editor-spinner"></div>
                <p style="font-size: 14px; color: #6b7280;">Loading image editor...</p>
            </div>
        `;
    }

    showError(message) {
        this.editorContent.innerHTML = `
            <div class="editor-error">
                <svg class="error-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 18.5c-.77.833.192 2.5 1.732 2.5z" />
                </svg>
                <p class="error-title">Image Error</p>
                <p class="error-message">${message}</p>
                <button type="button" class="editor-btn editor-btn-primary" onclick="imageEditor.handleCancel()">
                    Choose Different Photo
                </button>
            </div>
        `;
    }

    async loadImage(file) {
        return new Promise((resolve, reject) => {
            const imageUrl = URL.createObjectURL(file);
            const img = new Image();

            const timeout = setTimeout(() => {
                URL.revokeObjectURL(imageUrl);
                reject(new Error('Image loading timed out'));
            }, 30000);

            img.onload = () => {
                clearTimeout(timeout);
                this.imageElement = img;

                // Calculate initial scale and position
                const scaleX = this.CANVAS_WIDTH / img.naturalWidth;
                const scaleY = this.CANVAS_HEIGHT / img.naturalHeight;
                const initialScale = Math.min(scaleX, scaleY, 1);

                const scaledWidth = img.naturalWidth * initialScale;
                const scaledHeight = img.naturalHeight * initialScale;
                const initialX = (this.CANVAS_WIDTH - scaledWidth) / 2;
                const initialY = (this.CANVAS_HEIGHT - scaledHeight) / 2;

                this.imageState = {
                    scale: initialScale,
                    x: initialX,
                    y: initialY,
                    naturalWidth: img.naturalWidth,
                    naturalHeight: img.naturalHeight
                };

                resolve();
            };

            img.onerror = () => {
                clearTimeout(timeout);
                URL.revokeObjectURL(imageUrl);
                reject(new Error(`Failed to load image: ${file.name}. It may be corrupt or in an unsupported format.`));
            };

            img.src = imageUrl;
        });
    }

    setupCanvas() {
        this.editorContent.innerHTML = `
            <div class="canvas-container">
                <div class="canvas-wrapper">
                    <canvas id="imageCanvas" class="image-editor-canvas" 
                            width="${this.CANVAS_WIDTH}" 
                            height="${this.CANVAS_HEIGHT}"></canvas>
                </div>
            </div>
            <div class="editor-controls">
                <div class="zoom-controls">
                    <button type="button" class="editor-btn" onclick="imageEditor.handleZoomOut()">Zoom Out</button>
                    <button type="button" class="editor-btn" onclick="imageEditor.handleZoomIn()">Zoom In</button>
                    <button type="button" class="editor-btn" onclick="imageEditor.handleReset()">Reset</button>
                </div>
                <div class="action-controls">
                    <button type="button" class="editor-btn" onclick="imageEditor.handleCancel()">Choose Different Photo</button>
                    <button type="button" class="editor-btn editor-btn-primary" onclick="imageEditor.handleCrop()">Save & Preview</button>
                </div>
            </div>
            <div class="editor-status">
                <p>Scale: <span id="scalePercent">100</span>%</p>
            </div>
        `;

        this.canvas = document.getElementById('imageCanvas');
        this.ctx = this.canvas.getContext('2d');

        // Setup mouse events
        this.canvas.addEventListener('mousedown', (e) => this.handleMouseDown(e));
        this.canvas.addEventListener('mousemove', (e) => this.handleMouseMove(e));
        this.canvas.addEventListener('mouseup', () => this.handleMouseUp());
        this.canvas.addEventListener('mouseleave', () => this.handleMouseUp());

        // Touch events for mobile
        this.canvas.addEventListener('touchstart', (e) => this.handleTouchStart(e));
        this.canvas.addEventListener('touchmove', (e) => this.handleTouchMove(e));
        this.canvas.addEventListener('touchend', () => this.handleTouchEnd());
    }

    drawImage() {
        if (!this.ctx || !this.imageElement) return;

        // Clear canvas
        this.ctx.clearRect(0, 0, this.CANVAS_WIDTH, this.CANVAS_HEIGHT);

        // Fill with white background (from config: images.editor.fillColor)
        this.ctx.fillStyle = '#ffffff';
        this.ctx.fillRect(0, 0, this.CANVAS_WIDTH, this.CANVAS_HEIGHT);

        // Calculate scaled dimensions
        const scaledWidth = this.imageElement.naturalWidth * this.imageState.scale;
        const scaledHeight = this.imageElement.naturalHeight * this.imageState.scale;

        // Draw image
        this.ctx.drawImage(
            this.imageElement,
            this.imageState.x,
            this.imageState.y,
            scaledWidth,
            scaledHeight
        );

        // Draw crop overlay (from config: images.editor.cropBorderColor and cropBorderWidth)
        this.ctx.strokeStyle = '#2563eb';
        this.ctx.lineWidth = 2;
        this.ctx.setLineDash([5, 5]);
        this.ctx.strokeRect(0, 0, this.CANVAS_WIDTH, this.CANVAS_HEIGHT);
        this.ctx.setLineDash([]);

        // Update scale display
        const scalePercent = document.getElementById('scalePercent');
        if (scalePercent) {
            scalePercent.textContent = Math.round(this.imageState.scale * 100);
        }
    }

    handleMouseDown(e) {
        this.isDragging = true;
        const rect = this.canvas.getBoundingClientRect();
        this.dragStart = {
            x: e.clientX - rect.left - this.imageState.x,
            y: e.clientY - rect.top - this.imageState.y
        };
    }

    handleMouseMove(e) {
        if (!this.isDragging) return;
        const rect = this.canvas.getBoundingClientRect();
        this.imageState.x = e.clientX - rect.left - this.dragStart.x;
        this.imageState.y = e.clientY - rect.top - this.dragStart.y;
        this.drawImage();
    }

    handleMouseUp() {
        this.isDragging = false;
    }

    handleTouchStart(e) {
        e.preventDefault();
        const touch = e.touches[0];
        const rect = this.canvas.getBoundingClientRect();
        this.isDragging = true;
        this.dragStart = {
            x: touch.clientX - rect.left - this.imageState.x,
            y: touch.clientY - rect.top - this.imageState.y
        };
    }

    handleTouchMove(e) {
        e.preventDefault();
        if (!this.isDragging) return;
        const touch = e.touches[0];
        const rect = this.canvas.getBoundingClientRect();
        this.imageState.x = touch.clientX - rect.left - this.dragStart.x;
        this.imageState.y = touch.clientY - rect.top - this.dragStart.y;
        this.drawImage();
    }

    handleTouchEnd() {
        this.isDragging = false;
    }

    handleZoomIn() {
        const newScale = Math.min(this.imageState.scale * 1.2, 3);
        this.updateScale(newScale);
    }

    handleZoomOut() {
        const newScale = Math.max(this.imageState.scale / 1.2, 0.1);
        this.updateScale(newScale);
    }

    updateScale(newScale) {
        // Calculate center point
        const centerImageX = (this.CANVAS_WIDTH / 2 - this.imageState.x) / this.imageState.scale;
        const centerImageY = (this.CANVAS_HEIGHT / 2 - this.imageState.y) / this.imageState.scale;

        // Update scale and adjust position to maintain center
        this.imageState.scale = newScale;
        this.imageState.x = this.CANVAS_WIDTH / 2 - centerImageX * newScale;
        this.imageState.y = this.CANVAS_HEIGHT / 2 - centerImageY * newScale;

        this.drawImage();
    }

    handleReset() {
        // Reset to initial centered state
        const scaleX = this.CANVAS_WIDTH / this.imageState.naturalWidth;
        const scaleY = this.CANVAS_HEIGHT / this.imageState.naturalHeight;
        const initialScale = Math.min(scaleX, scaleY, 1);

        const scaledWidth = this.imageState.naturalWidth * initialScale;
        const scaledHeight = this.imageState.naturalHeight * initialScale;

        this.imageState.scale = initialScale;
        this.imageState.x = (this.CANVAS_WIDTH - scaledWidth) / 2;
        this.imageState.y = (this.CANVAS_HEIGHT - scaledHeight) / 2;

        this.drawImage();
    }

    async handleCrop() {
        if (!this.canvas || !this.imageElement) return;

        try {
            // Create crop canvas
            const cropCanvas = document.createElement('canvas');
            cropCanvas.width = this.CANVAS_WIDTH;
            cropCanvas.height = this.CANVAS_HEIGHT;
            const cropCtx = cropCanvas.getContext('2d');

            // Fill with white background
            cropCtx.fillStyle = '#ffffff';
            cropCtx.fillRect(0, 0, this.CANVAS_WIDTH, this.CANVAS_HEIGHT);

            // Calculate source rectangle
            const sourceX = Math.max(0, -this.imageState.x / this.imageState.scale);
            const sourceY = Math.max(0, -this.imageState.y / this.imageState.scale);
            const sourceWidth = Math.min(
                this.imageState.naturalWidth - sourceX,
                this.CANVAS_WIDTH / this.imageState.scale
            );
            const sourceHeight = Math.min(
                this.imageState.naturalHeight - sourceY,
                this.CANVAS_HEIGHT / this.imageState.scale
            );

            // Calculate destination rectangle
            const destX = Math.max(0, this.imageState.x);
            const destY = Math.max(0, this.imageState.y);
            const destWidth = sourceWidth * this.imageState.scale;
            const destHeight = sourceHeight * this.imageState.scale;

            // Draw cropped image
            cropCtx.drawImage(
                this.imageElement,
                sourceX, sourceY, sourceWidth, sourceHeight,
                destX, destY, destWidth, destHeight
            );

            // Convert to blob
            cropCanvas.toBlob((blob) => {
                const croppedFile = new File([blob], this.file.name || 'cropped-image.jpg', {
                    type: 'image/jpeg',
                    lastModified: Date.now()
                });

                // Call the crop callback
                if (this.onCrop) {
                    this.onCrop(croppedFile, {
                        x: this.imageState.x,
                        y: this.imageState.y,
                        width: this.CANVAS_WIDTH,
                        height: this.CANVAS_HEIGHT,
                        scale: this.imageState.scale
                    });
                }

                // Hide editor
                this.hide();
            }, 'image/jpeg', 0.92);
        } catch (error) {
            console.error('Error cropping image:', error);
        }
    }

    handleCancel() {
        // Clear the file input
        const fileInput = document.getElementById('file-upload');
        if (fileInput) {
            fileInput.value = '';
        }

        if (this.onCancel) {
            this.onCancel();
        }
        this.hide();
    }

    hide() {
        this.container.style.display = 'none';
        this.editorContent.innerHTML = '';

        // Cleanup
        if (this.imageElement && this.imageElement.src) {
            URL.revokeObjectURL(this.imageElement.src);
        }
    }
}

// Initialize editor instance
let imageEditor = null;

// Integration with your existing form
function initializeImageEditor() {
    imageEditor = new ImageEditor('imageEditorContainer');
}

// Call this when file is selected
function openImageEditor(file) {
    if (!imageEditor) {
        initializeImageEditor();
    }

    // Hide the file upload area
    // Hide the file upload area
    document.querySelector('.file-upload-area').style.display = 'none';
    document.getElementById('imagePreview').style.display = 'none';  // ADD THIS LINE

    // Show and initialize the editor
    imageEditor.init(
        file,
        function onCrop(croppedFile, cropData) {
            // Handle the cropped image
            console.log('Image cropped:', croppedFile, cropData);

            // Show preview of cropped image
            const reader = new FileReader();
            reader.onload = function(e) {
                document.getElementById('previewImg').src = e.target.result;

                const imagePreview = document.getElementById('imagePreview');
                imagePreview.style.display = 'flex';
                imagePreview.style.flexDirection = 'column';
                imagePreview.style.justifySelf = 'center';
                imagePreview.style.alignItems = 'center';
                const sizeInKB = Math.round(croppedFile.size / 1024);
                const badge = document.getElementById('fileSizeBadge');
                if (badge) {
                    badge.textContent = `Preview: Photo Area (${sizeInKB}KB)`;
                }

                // Store the cropped file for form submission
                window.croppedImageFile = croppedFile;

                // Update preview
                updatePreview();
            };
            reader.readAsDataURL(croppedFile);
        },
        function onCancel() {
            // Show the file upload area again OR the image preview if we have a cropped image
            if (window.croppedImageFile) {
                document.getElementById('imagePreview').style.display = 'block';
            } else {
                document.querySelector('.file-upload-area').style.display = 'block';
            }
        }
    );
}

// Modify your existing file input handler
document.addEventListener('DOMContentLoaded', function() {
    const fileInput = document.getElementById('file-upload');
    if (fileInput) {
        fileInput.addEventListener('change', function(e) {
            const file = e.target.files[0];
            if (file) {
                openImageEditor(file);
            }
        });
    }

    // Make entire upload area clickable (click + keyboard via role="button")
    const uploadArea = document.querySelector('.file-upload-area');
    if (uploadArea && fileInput) {
        uploadArea.addEventListener('click', function(e) {
            // Skip if click came from the label — it already triggers the file input natively
            if (e.target.closest('label[for="file-upload"]')) return;
            fileInput.click();
        });
    }
});

// Modify the edit image button handler
function editImage() {
    const fileInput = document.getElementById('file-upload');
    if (fileInput && fileInput.files[0]) {

        openImageEditor(fileInput.files[0]);
    } else if (window.croppedImageFile) {

        openImageEditor(window.croppedImageFile);
        document.getElementById('imagePreview').style.display = 'none';  // ADD THIS LINE
    }
}

function setPreviewLoading(isLoading) {
    const placeholder = document.getElementById('previewPlaceholder');
    const loading = document.getElementById('previewLoading');
    const imgWrap = document.getElementById('previewImage');
    const subtitle = document.getElementById('previewSubtitle');

    if (isLoading) {
        placeholder.style.display = 'none';
        loading.style.display = 'flex';
        imgWrap.style.display = 'none';
        subtitle.textContent = 'Fill out all fields to create your personalized card';
    } else {
        loading.style.display = 'none';
    }
}

function showPreviewImage(src) {
    const imgWrap = document.getElementById('previewImage');
    const img = document.getElementById('cardPreviewImg');
    const placeholder = document.getElementById('previewPlaceholder');
    const subtitle = document.getElementById('previewSubtitle');

    if (!src) {
        imgWrap.style.display = 'none';
        placeholder.style.display = 'flex';
        subtitle.textContent = 'Start filling out the form to preview your card';
        return;
    }
    img.src = src;
    imgWrap.style.display = 'block';
    placeholder.style.display = 'none';
    subtitle.textContent = 'Fill out all fields to create your personalized card';
}

// Build a FormData payload for the preview endpoint.
// Falls back gracefully if some fields are empty (preview accepts partials).
function buildPreviewFormData() {
    const fd = new FormData();

    const babyName = document.getElementById('babyName')?.value?.trim();
    const favoriteTeam = document.getElementById('favoriteTeam')?.value?.trim();
    const latestMilestone = document.getElementById('latestMilestone')?.value?.trim();
    const age = document.getElementById('age')?.value;
    const height = document.getElementById('height')?.value;
    const weight = document.getElementById('weight')?.value;
    const email = document.getElementById('email')?.value?.trim();
    const emailOptIn = document.querySelector('input[name="emailOptIn"]')?.value === 'true';

    if (babyName) fd.append('babyName', babyName);
    if (favoriteTeam) fd.append('favoriteTeam', favoriteTeam);
    if (latestMilestone) fd.append('latestMilestone', latestMilestone);
    if (age) fd.append('age', Number(age));
    if (height) fd.append('heightInches', Number(height));
    if (weight) fd.append('weightLbs', Number(weight));
    if (email) fd.append('email', email);
    fd.append('emailOptIn', String(emailOptIn));
    fd.append('theme', selectedTheme);
    // Prefer cropped image if available; otherwise, raw file input if present.
    const fileInputEl = document.getElementById('file-upload');
    const imageFile = (window.croppedImageFile) || (fileInputEl && fileInputEl.files && fileInputEl.files[0]);
    if (imageFile) fd.append('image', imageFile, imageFile.name || 'image.jpg');

    return fd;
}

// Debounced trigger (used by editor + form)
function requestPreviewDebounced() {
    clearTimeout(previewDebounce);
    previewDebounce = setTimeout(() => requestPreview(), PREVIEW_DEBOUNCE_MS);
}

// Main request to /api/cards/preview
async function requestPreview() {
    // Cancel any previous preview request still in flight
    if (previewReqAbort) {
        previewReqAbort.abort();
    }
    previewReqAbort = new AbortController();

    const hasAnyData =
        (document.getElementById('babyName')?.value?.trim()) ||
        (document.getElementById('favoriteTeam')?.value?.trim()) ||
        (document.getElementById('latestMilestone')?.value?.trim()) ||
        (document.getElementById('file-upload')?.files?.[0]) ||
        window.croppedImageFile;

    if (!hasAnyData) {
        showPreviewImage(null);
        return;
    }

    setPreviewLoading(true);

    try {
        const file =
            window.croppedImageFile ||
            document.getElementById('file-upload')?.files?.[0] ||
            null;

        // Build JSON payload; APIClient.previewCard will base64 the File/Blob
        const payload = {
            babyName: document.getElementById('babyName')?.value?.trim() || '',
            favoriteTeam: document.getElementById('favoriteTeam')?.value?.trim() || '',
            latestMilestone: document.getElementById('latestMilestone')?.value?.trim() || '',
            age: Number(document.getElementById('age')?.value || 0) || undefined,
            heightInches: Number(document.getElementById('height')?.value || 0) || undefined,
            weightLbs: Number(document.getElementById('weight')?.value || 0) || undefined,
            email: document.getElementById('email')?.value?.trim() || '',
            emailOptIn: !!document.getElementById('emailOptIn')?.checked,
            theme: selectedTheme, // Add theme here
            image: file || undefined, // pass File/Blob directly; the client will b64 it
        };

        // IMPORTANT: use the client’s JSON helper, not raw request with FormData
        const res = await apiClient.previewCard(payload, {
            signal: previewReqAbort.signal,
            skipFrontendToken: true
        });

        if (res && res.success && res.previewUrl) {
            showPreviewImage(res.previewUrl);
        } else {
            console.warn('Preview API returned unexpected payload:', res);
            showPreviewImage(null);
        }
    } catch (err) {
        if (err.name === 'AbortError') return;
        console.error('Preview request failed:', err);
        showPreviewImage(null);
    } finally {
        setPreviewLoading(false);
        previewReqAbort = null; // reset so next request starts clean
    }
}


// Team Members Dropdown

// NFL Teams Data (fallback if API fails)
const NFL_TEAMS_FALLBACK = [ ];

// Global state for teams
let NFL_TEAMS = [...NFL_TEAMS_FALLBACK];
let selectedTeam = null;
let filteredTeams = [...NFL_TEAMS];
let isTeamDropdownOpen = false;
let isLoadingTeams = false;

// Initialize on page load
document.addEventListener('DOMContentLoaded', async function() {
    // Render with fallback data immediately
    renderTeamList();

    // Fetch from API in background
    await fetchTeamsFromAPI();
});

// Fetch teams from API
async function fetchTeamsFromAPI() {
    if (isLoadingTeams) return;
    isLoadingTeams = true;
    try {
        console.log('Fetching teams from API...');
        // call directly, skip token for now
        const response = await apiClient.request('/api/teams', {
            method: 'GET',
            skipFrontendToken: true
        });

        if (response?.teams?.length) {
            NFL_TEAMS = response.teams.map(team => ({
                id: team.id || team.teamId,
                name: team.name || team.teamName,
                city: team.city || team.location,
                displayName: team.displayName || team.fullName || `${team.city || team.location} ${team.name || team.teamName}`,
                conference: team.conference || '',
                division: team.division || ''
            })).sort((a, b) => a.displayName.localeCompare(b.displayName));

            if (!selectedTeam) filteredTeams = [...NFL_TEAMS];
            if (isTeamDropdownOpen) renderTeamList();
        } else {
            console.warn('API returned empty or invalid teams data, using fallback');
        }
    } catch (err) {
        console.error('Failed to fetch teams:', err.message || err);
        console.log('Using fallback teams data');
    } finally {
        isLoadingTeams = false;
    }
}

// Render team list in dropdown
function renderTeamList() {
    const teamList = document.getElementById('teamList');
    if (!teamList) return;

    // Show loading state if still fetching
    if (isLoadingTeams && NFL_TEAMS.length === NFL_TEAMS_FALLBACK.length) {
        teamList.innerHTML = '<div class="team-selector-loading">Loading teams...</div>';
        return;
    }

    // Show no results if filtered list is empty
    if (filteredTeams.length === 0) {
        teamList.innerHTML = '<div class="team-selector-no-results">No teams found</div>';
        return;
    }

    // Render team buttons
    teamList.innerHTML = filteredTeams.map(team => {
        const isSelected = selectedTeam && selectedTeam.id === team.id;
        const displayName = team.displayName.replace(/'/g, '&#39;'); // Escape single quotes

        return `
            <button type="button"
                    class="team-selector-item ${isSelected ? 'selected' : ''}"
                    onclick="selectTeam('${team.id}')"
                    data-team-id="${team.id}"
                    role="option"
                    aria-selected="${isSelected ? 'true' : 'false'}">
                ${displayName}
            </button>
        `;
    }).join('');
}

// Toggle dropdown open/closed
function toggleTeamDropdown(event) {
    if (event) {
        event.preventDefault();
        event.stopPropagation();
    }

    const dropdown = document.getElementById('teamDropdown');
    const arrow = document.getElementById('teamArrow');
    const searchInput = document.getElementById('teamSearchInput');

    if (!dropdown || !arrow) return;

    if (isTeamDropdownOpen) {
        closeTeamDropdown();
    } else {
        // Open dropdown
        dropdown.style.display = 'block';
        arrow.style.transform = 'rotate(180deg)';
        isTeamDropdownOpen = true;
        const selectorBtn = document.getElementById('teamSelectorBtn');
        if (selectorBtn) selectorBtn.setAttribute('aria-expanded', 'true');

        // Reset search and show all teams
        if (searchInput) {
            searchInput.value = '';
            searchInput.focus();
        }
        filteredTeams = [...NFL_TEAMS];
        renderTeamList();

        // Try to fetch updated teams if not already loading
        if (!isLoadingTeams) {
            fetchTeamsFromAPI();
        }
    }
}

// Close dropdown
function closeTeamDropdown() {
    const dropdown = document.getElementById('teamDropdown');
    const arrow = document.getElementById('teamArrow');
    const searchInput = document.getElementById('teamSearchInput');

    if (dropdown) {
        dropdown.style.display = 'none';
    }
    if (arrow) {
        arrow.style.transform = 'rotate(0deg)';
    }
    if (searchInput) {
        searchInput.value = '';
    }

    isTeamDropdownOpen = false;
    const selectorBtn = document.getElementById('teamSelectorBtn');
    if (selectorBtn) selectorBtn.setAttribute('aria-expanded', 'false');

    // Reset filtered teams
    filteredTeams = [...NFL_TEAMS];
}

// Select a team
function selectTeam(teamId) {
    const team = NFL_TEAMS.find(t => t.id === teamId);
    if (!team) {
        console.error('Team not found:', teamId);
        return;
    }

    selectedTeam = team;

    // Update display text
    const selectedTeamText = document.getElementById('selectedTeamText');
    if (selectedTeamText) {
        selectedTeamText.textContent = team.displayName;
        selectedTeamText.classList.remove('placeholder');
    }

    // Update hidden input for form submission
    const favoriteTeamInput = document.getElementById('favoriteTeam');
    if (favoriteTeamInput) {
        favoriteTeamInput.value = team.id;
    }

    // Clear any error message
    const teamError = document.getElementById('teamError');
    if (teamError) {
        teamError.style.display = 'none';
        teamError.textContent = '';
    }

    // Update aria-selected on all items
    document.querySelectorAll('.team-selector-item').forEach(item => {
        item.setAttribute('aria-selected', item.dataset.teamId === teamId ? 'true' : 'false');
    });

    // Close dropdown
    closeTeamDropdown();

    // Trigger preview update if function exists
    if (typeof updatePreview === 'function') {
        updatePreview();
    }

    // Log selection
    console.log('Team selected:', team.displayName, '(', team.id, ')');
}

// Filter teams based on search input
function filterTeams(searchTerm) {
    const term = (searchTerm || '').trim().toLowerCase();

    if (term === '') {
        filteredTeams = [...NFL_TEAMS];
    } else {
        filteredTeams = NFL_TEAMS.filter(team => {
            const searchableText = `${team.displayName} ${team.city} ${team.name}`.toLowerCase();
            return searchableText.includes(term);
        });
    }

    renderTeamList();
}

// Get currently selected team
function getSelectedTeam() {
    return selectedTeam;
}

// Clear team selection
function clearTeamSelection() {
    selectedTeam = null;

    const selectedTeamText = document.getElementById('selectedTeamText');
    if (selectedTeamText) {
        selectedTeamText.textContent = 'Select your favorite team';
        selectedTeamText.classList.add('placeholder');
    }

    const favoriteTeamInput = document.getElementById('favoriteTeam');
    if (favoriteTeamInput) {
        favoriteTeamInput.value = '';
    }
}

// Validate team selection (for form validation)
function validateTeamSelection() {
    const favoriteTeamInput = document.getElementById('favoriteTeam');
    const teamError = document.getElementById('teamError');

    if (!favoriteTeamInput || !favoriteTeamInput.value) {
        if (teamError) {
            teamError.textContent = 'Please select a favorite team';
            teamError.style.display = 'block';
        }
        return false;
    }

    if (teamError) {
        teamError.style.display = 'none';
    }
    return true;
}

// Close dropdown when clicking outside
document.addEventListener('click', function(event) {
    const teamSelector = document.querySelector('.team-selector');
    if (teamSelector && !teamSelector.contains(event.target)) {
        closeTeamDropdown();
    }
});

// Handle keyboard navigation
document.addEventListener('keydown', function(event) {
    if (!isTeamDropdownOpen) return;

    const teamList = document.getElementById('teamList');
    if (!teamList) return;

    const items = teamList.querySelectorAll('.team-selector-item');
    const currentFocus = teamList.querySelector('.team-selector-item:focus');

    switch(event.key) {
        case 'Escape':
            closeTeamDropdown();
            break;
        case 'ArrowDown':
            event.preventDefault();
            if (!currentFocus && items.length > 0) {
                items[0].focus();
            } else if (currentFocus) {
                const index = Array.from(items).indexOf(currentFocus);
                if (index < items.length - 1) {
                    items[index + 1].focus();
                }
            }
            break;
        case 'ArrowUp':
            event.preventDefault();
            if (currentFocus) {
                const index = Array.from(items).indexOf(currentFocus);
                if (index > 0) {
                    items[index - 1].focus();
                }
            }
            break;
        case 'Enter':
            if (currentFocus) {
                event.preventDefault();
                currentFocus.click();
            }
            break;
    }
});

// Function to handle card generation
async function handleGenerateCard(event) {
    event.preventDefault();

    // First validate the form
    if (!validateForm(event)) {
        return false;
    }

    // Show loading state
    const submitBtn = document.getElementById('submitBtn');
    const submitText = document.getElementById('submitText');
    const loadingSpinner = document.getElementById('loadingSpinner');

    submitBtn.disabled = true;
    submitBtn.setAttribute('aria-busy', 'true');
    submitText.textContent = 'Generating Your Card...';
    loadingSpinner.style.display = 'block';
    isGenerating = true;

    try {
        // Prepare the form data
        const formData = {
            babyName: document.getElementById('babyName').value.trim(),
            favoriteTeam: document.getElementById('favoriteTeam').value.trim(),
            latestMilestone: document.getElementById('latestMilestone').value.trim(),
            age: Number(document.getElementById('age').value),
            heightInches: Number(document.getElementById('height').value),
            weightLbs: Number(document.getElementById('weight').value),
            email: document.getElementById('email').value.trim(),
            emailOptIn: document.getElementById('emailOptIn').checked,
            theme: selectedTheme, // Add theme here
            image: window.croppedImageFile || document.getElementById('file-upload').files[0]
        };

        // Call the generate API
        const response = await apiClient.generateCard(formData);

        if (response && response.success) {
            generatedCardData = normalizeCard(response);

            const babyName = document.getElementById('babyName')?.value?.trim() || '';
            const favTeam = document.getElementById('favoriteTeam')?.value?.trim() || '';

            if (babyName) {
                generatedCardData.babyName = babyName;

            }
            if (favTeam) {
                generatedCardData.teamId = favTeam;

            }


            generatedCardData.theme = selectedTheme;
            // Update URL with cardId
            const params = new URLSearchParams(window.location.search);
            params.set('cardId', generatedCardData.id);
            const newUrl = `${window.location.pathname}?${params.toString()}`;
            window.history.pushState({ cardId: generatedCardData.id }, '', newUrl);

            showGeneratedCard(generatedCardData);
            window.scrollTo({ top: 0, behavior: 'smooth' });

        } else {
            throw new Error(response?.message || 'Failed to generate card');
        }
    } catch (error) {
        console.error('Error generating card:', error);
        alert('Failed to generate your trading card. Please try again.');
    } finally {
        // Reset button state
        submitBtn.disabled = false;
        submitBtn.setAttribute('aria-busy', 'false');
        submitText.textContent = 'Generate your card';
        loadingSpinner.style.display = 'none';
        isGenerating = false;
    }

    return false;
}

// Function to show generated card UI
function showGeneratedCard(cardData) {
    // Hide the form and preview panels
    document.querySelector('.split-screen-grid').style.display = 'none';
    document.querySelector('.mobile-toggle').style.display = 'none';
    document.querySelector('.mobile-preview-button').style.display = 'none';

    // Hide the other page sections (multi-image banner and two-column sections)
    const bannerSection = document.querySelector('[id*="multi_image_banner"]');
    const twoColumnSection = document.querySelector('[id*="section_two_column"]');
    if (bannerSection) bannerSection.style.display = 'none';
    if (twoColumnSection) twoColumnSection.style.display = 'none';

    // Show the generated card container
    const generatedContainer = document.getElementById('generatedCardContainer');
    if (generatedContainer) {
        generatedContainer.classList.add('active');

        // Update the generated card image
        const cardImage = document.getElementById('generatedCardImage');
        if (cardImage) cardImage.src = cardData.imageUrl;

        const cardTitle = document.querySelector('.generated-card-title');
        if (cardTitle) {
            const team = cardData.teamId ? cardData.teamId + " " : "";
            cardTitle.textContent = (cardData.babyName ? cardData.babyName + "'s " : "") + team + "Trading Card";
        }

        const created = new Date(cardData.createdAt);
        document.getElementById('cardCreatedDate')?.replaceChildren(
            document.createTextNode(created.toLocaleDateString())
        );
        document.getElementById('cardIdDisplay')?.replaceChildren(
            document.createTextNode(cardData.id)
        );

        // Header “Created on …” (from my earlier HTML/CSS reply)
        const createdHeader = document.getElementById('generatedCreatedOnText');
        if (createdHeader) {
            createdHeader.replaceChildren(document.createTextNode(created.toLocaleDateString()));
        }

        // Store share URL for social sharing
        window.currentShareUrl = cardData.shareUrl;
        window.currentImageUrl = cardData.imageUrl;
    }
}

// Function to start over
function startOver() {
    // Build new URL with ?view=trading-card
    const newUrl = `${window.location.pathname}?view=trading-card`;

    // Push new URL to history
    window.history.pushState({}, '', newUrl);
    selectedTheme = 'light';
    selectLogo('light');

    // Optionally reset state immediately (in case reload is slow)
    document.querySelector('.upload-form')?.reset();
    removeImage();
    clearTeamSelection();
    document.getElementById('generatedCardContainer')?.classList.remove('active');

    // Reload page so UI fully resets with new query param
    window.location.reload();
}

function downloadCard() {
    if (!generatedCardData) return;

    try {
        // Open the image in a new tab
        window.open(generatedCardData.imageUrl, '_blank');
    } catch (error) {
        console.error('Download failed:', error);
        alert('Failed to open the image. Please try again.');
    }
}

// Social sharing functions
function shareOnFacebook() {
    const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.currentShareUrl)}`;
    window.open(url, '_blank', 'width=600,height=400');
}

function shareOnTwitter() {
    const text = "Check out my personalized Gerber trading card! 🏈👶";
    const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(window.currentShareUrl)}&hashtags=GerberBaby,TradingCard`;
    window.open(url, '_blank', 'width=600,height=400');
}

function shareOnPinterest() {
    const description = "My personalized Gerber trading card!";
    const url = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(window.currentShareUrl)}&media=${encodeURIComponent(window.currentImageUrl)}&description=${encodeURIComponent(description)}`;
    window.open(url, '_blank', 'width=600,height=400');
}

function shareViaEmail() {
    const subject = "My Gerber Trading Card";
    const body = `Check out my personalized Gerber trading card!\n\nView it here: ${window.currentShareUrl}`;
    window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

function copyShareLink() {
    navigator.clipboard.writeText(window.currentShareUrl).then(() => {
        alert('Link copied to clipboard!');
    }).catch(() => {
        alert('Failed to copy link. Please copy manually: ' + window.currentShareUrl);
    });
}


// Check for cardId on page load
document.addEventListener('DOMContentLoaded', async function() {
    const urlParams = new URLSearchParams(window.location.search);
    const cardId = urlParams.get('cardId');

    if (cardId) {
        try {
            // Fetch card details from API
            const response = await apiClient.getCard(cardId);

            if (response && response.success) {
                generatedCardData = normalizeCard(response);
                showGeneratedCard(generatedCardData);
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        } catch (error) {
            console.error('Failed to load card:', error);
            // If card not found, just show the normal form
        }
    }
});

// Update the existing validateForm function to call handleGenerateCard
// Replace the form's onsubmit with the new handler
document.addEventListener('DOMContentLoaded', function() {
    const form = document.querySelector('.upload-form');
    if (form) {
        form.onsubmit = handleGenerateCard;
    }
});